export default __webpack_public_path__ + "static/media/2.d5ff3d8e.jpg";